// extracted by mini-css-extract-plugin
module.exports = {"file-icon-wrapper":"styles_file-icon-wrapper__1Jl63","image":"styles_image__39ZNg","file-icon":"styles_file-icon__1YQQe","remove-file-button":"styles_remove-file-button__16hEe"};